<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-03-01 14:42:48
 * @LastEditTime: 2022-03-11 10:48:08
 * @Description: file content
-->
<template >
  <el-dialog
    v-dialogDrag
    :title="`选择值`"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :loading.sync="loading"
    top="5vh"
    width="70%"
    class="self-dialog-form"
    :append-to-body="true"
  >
    <div v-if="tableHeaders.length > 0" v-loading="loadingTable" class="h100">
      <general-table
        ref="generalTable"
        code="DataMetaQuery"
        :checkbox="true"
        :columns="tableHeaders"
        :data="tableData"
        :batch-delete="false"
        :reserve-selection="true"
        search-mode=""
        :operable="false"
        :pagination="pagination"
        :hide-oper-button="true"
        default-expand-all
        :tree-props="{ children: 'children' }"
        @handleSizeChange="onPageChange"
        @handleCurrentChange="onPaginationSizeChange"
      >
        >
        <template #code="{ scope }">
          <el-select
            v-model="selectedItemCode"
            class="w-full pt-3 pb-3"
            placeholder="请选择业务对象"
            @change="changeItemSource"
          >
            <el-option
              v-for="item in selectedStruct.fields"
              :key="item.id"
              :label="item.fieldName"
              :value="item.id"
            />
          </el-select>
        </template>
        <template #operation="{ scope }">
          <el-button type="text" class="cursor-p" width="200" @click="handleAssignRoles(scope.row)">
            {{ $t('user.assignRoles') }}
          </el-button>
        </template>
      </general-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";

export default {
  name: "DataMetaQuery",
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    structCode: {
      type: String,
      default: () => null
    },
    multipleSelected: {
      type: Boolean,
      default: () => false
    },
    defaultSelection: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default() {
        return "";
      }
    },
    isTree: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      loading: false,
      loadingTable: false,
      tableHeaders: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      selectedStructCode: "",
      selectedStruct: {},
      selectedItemCode: "",
      metadata: {},
      metadataDetail: {},
      selection: [],
      showFieldCode: ""
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
          total: 0
        };
        this.loadData();
      }
    },
    defaultSelection() {
      this.selection = JSON.parse(JSON.stringify(this.defaultSelection));
    }
  },
  mounted() {
    this.selection = JSON.parse(JSON.stringify(this.defaultSelection));
    this.loadHeader();
  },
  methods: {
    /**
     * @description: 获取table header
     * @param {*}
     * @return {*}
     */
    loadHeader() {
      dataApi
        .getMetadataStructByCode(this.structCode)
        .then(res => {
          if (res.success && res.data) {
            this.showFieldCode = res.data.showFieldCode;
            this.initTableHeader(res.data.fields);
            this.loadData();
          }
        })
        .catch(() => {});
    },
    loadData() {
      this.tableData = [];
      if (this.structCode) {
        this.loadingTable = true;
        let size = this.pagination.pageSize;
        if (this.isTree) {
          size = -1;
        }
        dataApi
          .getMetadataInstance(this.structCode, this.structCode, this.pagination.pageNum, size)
          .then(res => {
            this.loadingTable = false;
            if (res && res.success) {
              const data = res.data;
              if (data) {
                this.$nextTick(() => {
                  this.initTableData(data.objects, this.showFieldCode);
                  // this.tableData = data.objects;
                  this.pagination.total = data.total;
                });
              }
            }
          })
          .catch(() => {
            this.loadingTable = false;
          });
      }
    },
    initTableHeader(objects) {
      this.tableHeaders = [];
      objects.forEach(element => {
        const showType = element.showType;
        if (showType === "TEXT" || showType === "NUMBER") {
          const item = {
            label: element.fieldName,
            key: element.fieldCode,
            hidden: false,
            fixed: false
          };
          this.tableHeaders.push(item);
        }
      });
    },
    initTableData(objects, showFieldCode) {
      const tempData = [];
      const treeArray = [];
      objects.forEach(element => {
        element["showFieldCode"] = showFieldCode;
        element["showValue"] = element[showFieldCode];
        tempData.push(element);
        if (this.isTree) {
          this.initTreeArray(treeArray, element);
        }
      });
      if (this.isTree) {
        // this.tableData = [{ children: [] }];
        treeArray.forEach(element => {
          const root = !this.initTreeData(treeArray, element);
          if (root) {
            this.tableData.push(...element.children);
          }
        });
        console.log(this.tableData);
      } else {
        this.tableData = tempData;
      }

      this.initObjectSelected();
    },
    /**
     * @description: 把同一个parentId的数据分组
     * @param {*} treeArray
     * @param {*} element
     * @return {*}
     */
    initTreeArray(treeArray, element) {
      let tempItem = null;
      for (let index = 0; index < treeArray.length; index++) {
        const item = treeArray[index];
        if (item.parentId === element.parentId) {
          item.children.push(element);
          tempItem = item;
          break;
        }
      }
      if (tempItem === null) {
        tempItem = {
          parentId: element.parentId,
          children: [element]
        };
        treeArray.push(tempItem);
      }
    },
    /**
     * @description: 格式化树
     * @param {*} dataArray
     * @return {*}
     */
    initTreeData(dataArray, element) {
      let isChild = false;
      for (let index = 0; index < dataArray.length; index++) {
        const item = dataArray[index];
        if (item.children) {
          for (let index2 = 0; index2 < item.children.length; index2++) {
            const item2 = item.children[index2];
            if (item2.id === element.parentId) {
              item2.children = element.children;
              return true;
            } else if (item2.children) {
              isChild = this.initTreeData(item2.children, element);
              if (isChild) {
                return true;
              }
            }
          }
        }
      }
      return isChild;
    },
    initObjectSelected() {
      // 获取当前组织的用户信息
      // 默认选中
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.selection.forEach((element, index) => {
            if (element.toString() === item[this.valueKey].toString()) {
              this.selection.splice(index, 1);
              this.$refs.generalTable.toggleRowSelection(item, true);
            }
          });
        });
      });
    },
    /**
     * @description: 分页
     * @param {*} pageSize
     * @return {*}
     */
    onPageChange({ pageNum }) {
      this.pagination.pageNum = pageNum;
      this.loadData();
    },

    /**
     * @description: 分页
     * @param {*} pageNum
     * @param {*} pageSize
     * @return {*}
     */
    onPaginationSizeChange({ pageSize }) {
      this.pagination.pageSize = pageSize;
      this.loadData();
    },
    handleConfirm() {
      this.dialogVisible = false;
      this.$emit("valueChange", this.$refs.generalTable.multipleSelection);
    }
  }
};
</script>
<style lang="">
</style>
